module.exports = __webpack_public_path__ + "static/media/porte1.6af86db7.jpg";